exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* select {\r\n  min-width: 275px;\r\n} */\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Biziclick/bizisystem/src/app/shared/agency-selection/agency-selection.component.css
// module id = ../../../../../src/app/shared/agency-selection/agency-selection.component.css
// module chunks = main